var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContactUsIconDynamic = function SvgContactUsIconDynamic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.421 12.24C17.3718 12.2032 13.8 9.7716 12.8196 9.94613C12.3516 10.0243 12.084 10.3258 11.547 10.9293C11.4606 11.0268 11.253 11.2602 11.0916 11.4263C10.7522 11.3217 10.4212 11.1945 10.101 11.0455C8.44831 10.2856 7.113 9.02444 6.3084 7.46357C6.15052 7.1612 6.01577 6.84855 5.9052 6.528C6.0816 6.375 6.3288 6.17893 6.4344 6.09507C7.0704 5.59073 7.3902 5.338 7.473 4.89487C7.6428 3.97687 5.07 0.580267 5.043 0.549667C4.92627 0.392173 4.77393 0.261155 4.597 0.166092C4.42008 0.0710281 4.22299 0.014296 4.02 0C2.9772 0 0 3.64763 0 4.2619C0 4.2976 0.0546 7.92653 4.7928 12.4786C9.6078 16.9484 13.4496 17 13.4874 17C14.1384 17 18 14.1882 18 13.2033C17.985 13.0123 17.9253 12.8268 17.8252 12.6602C17.7251 12.4936 17.587 12.3501 17.421 12.24Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactUsIconDynamic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact-us-icon-dynamic.8ea9ad26.svg";
export { ForwardRef as ReactComponent };